import React, {useState, useEffect} from 'react';
import { API_URL } from '../config';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Admin from './pages/Admin';
import Annonce from './pages/Annonce';
import Dashbord from './pages/Dashbord';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import User from './pages/User';
import Navigation from './tools/Navigation';
import useUserSession from './useUserSession';
import Recherche from './pages/Recherche';
import Newsletter from './pages/Newsletter';

function ProtectedRoute({ children }) {
  const { user, loading } = useUserSession();

  // Afficher un état de chargement si nécessaire
  if (loading) {
    return <div>Chargement...</div>;
  }

  // Redirige vers /login si l'utilisateur n'est pas connecté
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  const { user } = useUserSession();
  const location = useLocation();

  const [users, setUsers] = useState([]); // État pour stocker les utilisateurs
  const [announcements, setAnnouncements] = useState({}); // État pour stocker les annonces
  const [announcements2, setAnnouncements2] = useState([]); // État pour stocker les annonces de status container
  const [announcements3, setAnnouncements3] = useState([]); // État pour stocker les annonces de status kilos
  const [, setLoading2] = useState(true); // État pour gérer le chargement
  const [, setError2] = useState(null); // État pour gérer les erreurs
  const [, setLoading3] = useState(true); // État pour gérer le chargement
  const [, setError3] = useState(null); // État pour gérer les erreurs

  const [data4, setData4] = useState([]); // État pour stocker les données
  const [, setLoading4] = useState(true); // État pour indiquer le chargement
  const [, setError4] = useState(null); // État pour gérer les erreurs

  useEffect(() => {
    // Fonction pour récupérer les données
    const fetchData = async () => {
      try {
        
        setLoading4(true); // Active l'indicateur de chargement
        const token = localStorage.getItem("token"); // Récupère le token depuis le localStorage

        const response = await fetch(`${API_URL}/api/search/getsearch`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des données");
        }
        const result = await response.json();
        setData4(result); // Stocke les données récupérées
      } catch (err) {
        setError4(err.message); // Stocke le message d'erreur
      } finally {
        setLoading4(false); // Désactive l'état de chargement
      }
    };

    if(localStorage.length !==0 && user){
      fetchData();
    }
  }, [user]);


  // Fonction réutilisable pour transformer les données
  const transformData = (data) => {
      if (!data.announcements || !Array.isArray(data.announcements)) {
        console.error("Les données des annonces sont invalides :", data);
        return {};
      }
    
      return data.announcements.reduce((acc, announcement) => {
        const key = announcement.status; // "kilos" ou "container"
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(announcement);
        return acc;
      }, {});
  };

  
  useEffect(() => {
    // Fonction pour récupérer les annonces inactives
    const fetchInactiveKilo = async () => {
      try {
        setLoading3(true); // Active l'indicateur de chargement
        const token = localStorage.getItem("token"); // Récupère le token depuis le localStorage

        const response = await fetch(`${API_URL}/api/annonce/getfalsekilo`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          // Vérifie si la réponse HTTP est correcte
          throw new Error(`Erreur : ${response.status} ${response.statusText}`);
        }

        const data = await response.json(); // Convertit la réponse en JSON

        if (data.status === 0) {
          setAnnouncements3(data.announcements); // Met à jour l'état avec les annonces
        } else {
          throw new Error(data.message || "Erreur lors de la récupération des données");
        }
      } catch (err) {
        setError3(err.message); // Met à jour l'état des erreurs
      } finally {
        setLoading3(false); // Désactive l'indicateur de chargement
      }
    };

    if(localStorage.length !==0 && user){
      fetchInactiveKilo();
    }
}, [user]); // Le tableau vide [] garantit que l'effet ne s'exécute qu'une fois


  useEffect(() => {
      // Fonction pour récupérer les annonces inactives
      const fetchInactiveContainers = async () => {
        try {
          setLoading2(true); // Active l'indicateur de chargement
          const token = localStorage.getItem("token"); // Récupère le token depuis le localStorage
  
          const response = await fetch(`${API_URL}/api/annonce/getfalsecontainer`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
              "Content-Type": "application/json",
            },
          });
  
          if (!response.ok) {
            // Vérifie si la réponse HTTP est correcte
            throw new Error(`Erreur : ${response.status} ${response.statusText}`);
          }
  
          const data = await response.json(); // Convertit la réponse en JSON
  
          if (data.status === 0) {
            setAnnouncements2(data.announcements); // Met à jour l'état avec les annonces
          } else {
            throw new Error(data.message || "Erreur lors de la récupération des données");
          }
        } catch (err) {
          setError2(err.message); // Met à jour l'état des erreurs
        } finally {
          setLoading2(false); // Désactive l'indicateur de chargement
        }
      };

      if(localStorage.length !==0 && user){
        fetchInactiveContainers();
      }
  }, [user]);
  
  useEffect(() => {
    // Fonction pour récupérer les utilisateurs
    const fetchUsers = async () => {
      try {
        setLoading2(true); // Démarre le chargement
        const token = localStorage.getItem('token'); // Récupère le token depuis le localStorage
        const role = localStorage.getItem('role');
        const response = await fetch(`${API_URL}/api/user/getallusers`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            role: role,
          }),
        });
        if (!response.ok) {
          // Gère les erreurs HTTP
          throw new Error(`Erreur : ${response.status} ${response.statusText}`);
        }
        const data = await response.json();

        if (data.status === 0) {
          setUsers(data.users); // Met à jour l'état avec les utilisateurs
        } else {
          throw new Error(data.message || 'Erreur lors de la récupération des utilisateurs');
        }
      } catch (err) {
        setError2(err.message); // Gère les erreurs
      } finally {
        setLoading2(false); // Termine le chargement
      }
    };

    if(localStorage.length !==0 && user){
      fetchUsers();
    }
  }, [user]);

  useEffect(() => {
      // Fonction pour récupérer les annonces valides
      const fetchValidAnnouncements = async () => {
        try {
          setLoading2(true); // Active l'indicateur de chargement
          const token = localStorage.getItem("token"); // Récupère le token depuis le localStorage
  
          const response = await fetch(`${API_URL}/api/annonce/getvalidannouncements`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`, // Ajoute le token au header Authorization
              "Content-Type": "application/json",
            },
          });
  
          if (!response.ok) {
            // Vérifie si la réponse HTTP est correcte
            throw new Error(`Erreur : ${response.status} ${response.statusText}`);
          }
  
          const data = await response.json(); // Convertit la réponse en JSON
  
          if (data.status === 0) {
            const dataP = transformData(data)
            setAnnouncements(dataP); // Met à jour l'état avec les annonces
          } else {
            throw new Error(data.message || "Erreur lors de la récupération des données");
          }
        } catch (err) {
          setError2(err.message); // Met à jour l'état des erreurs
        } finally {
          setLoading2(false); // Désactive l'indicateur de chargement
        }
      };

      if(localStorage.length !==0 && user){
        fetchValidAnnouncements();
      }
  }, [user]);

  //script permettant de recupérer les recherche

  /* if (loading) {
    return <div>Chargement en cours...</div>;
  } */

  // Redirige l'utilisateur connecté depuis /login vers /
  if (location.pathname === '/login' && user) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {/* Afficher la barre de navigation uniquement si l'utilisateur est connecté */}
      {user && <Navigation />}

      <Routes>
        {/* Route publique : Login */}
        <Route
          path="/login"
          element={
            !user ? (
              <Login />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* Routes protégées */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashbord users={users} announcements={announcements} announcements2={announcements2} announcements3={announcements3}/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin users={users} announcements={announcements}/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/annonce"
          element={
            <ProtectedRoute>
              <Annonce  users={users} announcements={announcements}/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/recherche"
          element={
            <ProtectedRoute>
              <Recherche  users={users} recherche={data4} announcements={announcements}/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRoute>
              <User users={users} announcements={announcements}/>
            </ProtectedRoute>
          }
        />

        <Route
          path="/newsletter"
          element={
            <ProtectedRoute>
              <Newsletter />
            </ProtectedRoute>
          }
        />

        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
